import { Box, Link, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { TitleDivider } from "../titleDivider";
import { observer } from "mobx-react";
import { InternalValuationReviewStore } from "../../stores/internalValuationReviewStore";
import { CompMap, MapLegend } from "../mapComponents";
import { ComparablesTable } from "../comparablesTable";
import { FieldSetBox } from "../fieldSetBox";

const useStyles = makeStyles((theme: Theme) => ({
  tabContent: {
    backgroundColor: "#FFFFFF",
    padding: "2rem",
  },
  mapContainer: {
    height: "504px",
    width: "100%",
    position: "relative"
  },
  legendContainer: {
    height: "100%",
    overflow: "auto"
  }
}));

interface ComparableAnalysisTabProps {
  internalValuationReviewStore: InternalValuationReviewStore;
}

export const ComparableAnalysisTab = observer(({ internalValuationReviewStore }: ComparableAnalysisTabProps) => {
  const classes = useStyles();

  const markers = internalValuationReviewStore.getPropertyCompsMarkers();

  const markersCount = markers?.length || 0;
  const compsAvailable = markers && markers.length > 0;

  const handleClickCompToolLink = () => {
    window.open(internalValuationReviewStore.getCompToolUrl());
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap="1rem"
      className={classes.tabContent}
    >
      <TitleDivider title="Comparable Analysis" />

      {compsAvailable && (
        <>
          <Box className={classes.mapContainer}>
            <CompMap markers={markers} />
            <Box
              style={{
                position: "absolute",
                top: 15,
                right: 0,
                height: markersCount > 3 ? "60%" : "auto"
              }}
            >
              <FieldSetBox title="Legend" className={markersCount > 3 ? classes.legendContainer : null}>
                <MapLegend markers={markers} liteMode />
              </FieldSetBox>
            </Box>
          </Box>
          <ComparablesTable internalValuationReviewStore={internalValuationReviewStore} />
        </>)}
      {!compsAvailable && (<Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        style={{
          height: "300px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          padding: "20px",
        }}
      >
        {internalValuationReviewStore.isInternalPortal && (
          <>
            <Typography variant="h6">
              No comparable properties found. Please visit the Comp Tool to add and save comps to proceed.
            </Typography>
            <Link style={{ cursor: "pointer" }} onClick={handleClickCompToolLink}>Click here to go to Comp Tool</Link>
          </>)}
        {!internalValuationReviewStore.isInternalPortal && (
          <Typography variant="h6">
            No comparable properties found for this valuation.
          </Typography>
        )}
      </Box>)}

    </Box>
  );
});
